import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const ErrorPage = () => {
    const navigate=useNavigate()
  return (
    <div style={{ textAlign: 'center', padding: '2rem' }}>
      <h1>404 - Page Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      <Link   onClick={()=>{
        navigate(-1)
      }} >Go Back to Dashboard</Link>
    </div>
  );
};

export default ErrorPage;
